import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import './ScrollTicker.css'

const logos = [
  { name: 'JavaScript', src: 'https://cdn.simpleicons.org/javascript/F7DF1E' },
  { name: 'Python',     src: 'https://cdn.simpleicons.org/python/3776AB' },
  { name: 'PHP',        src: 'https://cdn.simpleicons.org/php/777BB4' },
  { name: 'Bootstrap',  src: 'https://cdn.simpleicons.org/bootstrap/7952B3' },
  { name: 'Flask',      src: 'https://cdn.simpleicons.org/flask/3BABC3' },
  { name: 'PostgreSQL', src: 'https://cdn.simpleicons.org/postgresql/4169E1' },
  { name: 'React',      src: 'https://cdn.simpleicons.org/react/61DAFB' },
  { name: 'Redux',      src: 'https://cdn.simpleicons.org/redux/764ABC' },
  { name: 'Laravel',    src: 'https://cdn.simpleicons.org/laravel/FF2D20' },
  { name: 'Symfony',    src: 'https://cdn.simpleicons.org/symfony' },
  { name: 'MySQL',      src: 'https://cdn.simpleicons.org/mysql/4479A1' },
  { name: 'MongoDB',    src: 'https://cdn.simpleicons.org/mongodb/47A248' },
  { name: 'Firebase',   src: 'https://cdn.simpleicons.org/firebase/FFCA28' },
  { name: 'GitHub',     src: 'https://cdn.simpleicons.org/github' },
  { name: 'Docker',     src: 'https://cdn.simpleicons.org/docker/2496ED' },
]

const isTouch = () => 'ontouchstart' in window || navigator.maxTouchPoints > 0

const ScrollTicker = () => {
  const { t } = useTranslation()
  const trackRef = useRef(null)

  const pause  = () => { if (!isTouch() && trackRef.current) trackRef.current.style.animationPlayState = 'paused' }
  const resume = () => { if (!isTouch() && trackRef.current) trackRef.current.style.animationPlayState = 'running' }

  return (
    <section className='section' id='stack'>
      <h2 className='section__title' data-aos="zoom-out">
        {t('stack')}
      </h2>
      <div
        className='marquee-wrapper'
        data-aos="fade-in"
        onMouseEnter={pause}
        onMouseLeave={resume}
        style={isTouch() ? { pointerEvents: 'none' } : {}}
      >
        <div className='marquee-track' ref={trackRef}>
          {[...logos, ...logos].map((logo, i) => (
            <div className='marquee-item' key={i}>
              <img src={logo.src} alt={logo.name} />
              <span>{logo.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default ScrollTicker
